<template>
  <v-bottom-navigation grow color="#ff9117" :value="activeBtn ? activeBtn : 0" class="elevation-5" app>
      <v-btn value="home" v-on:click="navigateToHome">
        <span>Startseite</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn value="pick" v-on:click="navigateToPick">
        <span>Pick</span>
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </v-bottom-navigation>
</template>

<script>
export default {
  name: "BottomNavigation",
  props: [
    "activeBtn",
  ],
  methods: {
    navigateToHome() {
        this.$router.push("/");
    },
    navigateToPick() {
        this.$router.push("/pick");
    }
  }
};
</script>

<style scoped></style>